import React from 'react';
import ClickableImage from "../../Components/ClickableImage";
import {BaseComponent, PhotoModel} from "../../types/protocols";
import "./BuildingImagesSection.css"

interface BuildingSectionProps {
    title: string;
    label?: string;
    components?: { [key: string]: BaseComponent };
    buildingKey: string;
    onImageClick: (photo: PhotoModel, fullUrl: string) => void;
    selectedImageKey: string | undefined;
    useDivider?: boolean;
}

const BuildingImagesSection: React.FC<BuildingSectionProps> = ({
                                                                   title,
                                                                   components,
                                                                   buildingKey,
                                                                   onImageClick,
                                                                   selectedImageKey,
                                                                   useDivider
                                                               }) => {
    if (!components) return null;

    return (
        <div>
            {useDivider && <div style={{ height: '2px', marginBottom: '35px', marginTop: '5px', backgroundColor: "#dddddd" }} />}
            <h3 style={{ textAlign: 'left', marginBottom: '20px' }}>{title}</h3>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "15px",
                    padding: useDivider ? "0px" : "30px",
                    gap: '40px',
                    backgroundColor: useDivider ? "transparent" : "#fff",
                    textAlign: "left",
                    boxShadow: useDivider ? '' : '0 4px 6px rgba(0, 0, 0, 0.1)',
                }}
            >
                {Object.values(components).map((item, index) => (
                    <div key={index}>
                        <h5>{"item.displayName()"}</h5>
                        {item.photos && Object.values(item.photos).length > 0 ? (
                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                {Object.values(item.photos).map((photo) => (
                                    <ClickableImage
                                        key={photo.key || photo.smallSizeUrl}
                                        photo={photo}
                                        buildingKey={buildingKey}
                                        showDate={true}
                                        onImageClick={onImageClick}
                                        highlighted={photo.key === selectedImageKey}
                                    />
                                ))}
                            </div>
                        ) : (
                            <p>Inga foton</p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BuildingImagesSection;